export default "__VITE_ASSET__BG1Ssp_x__"